/**
 * @generated SignedSource<<15a517aa638727f273ef3c3074daee09>>
 * @relayHash c1ad8ee87b03a58317a6ee2775b4991d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac99a3743c5c7cd649bde128b367c610c1fc18db8e223bac366fc2c8a58cafbe

import type { ConcreteRequest, Query } from 'relay-runtime';
export type settingsFormV2Query$variables = {
  cloudId: string;
  projectKey: string;
};
export type settingsFormV2Query$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly id: string;
      readonly virtualAgentConfiguration: {
        readonly id?: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly isAiEnabledInAdminHub: boolean | null | undefined;
      readonly isVirtualAgentAvailable: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type settingsFormV2Query = {
  response: settingsFormV2Query$data;
  variables: settingsFormV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "concreteType": "VirtualAgentQueryApi",
  "kind": "LinkedField",
  "name": "virtualAgent",
  "plural": false,
  "selections": [
    {
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "VirtualAgentFeatures",
      "kind": "LinkedField",
      "name": "virtualAgentEntitlements",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAiEnabledInAdminHub"
        },
        {
          "kind": "ScalarField",
          "name": "isVirtualAgentAvailable"
        }
      ]
    }
  ]
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "VirtualAgentConfiguration"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "settingsFormV2Query",
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "settingsFormV2Query",
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "VirtualAgentQueryError"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ac99a3743c5c7cd649bde128b367c610c1fc18db8e223bac366fc2c8a58cafbe",
    "metadata": {},
    "name": "settingsFormV2Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b9507688dac643610c096ca318ab02a6";

export default node;
